import { MAIN_COLOR } from 'shared/consts';
import styled from 'styled-components';

export type WrapperProps = {
  $direction?: string,
  $gap?: string;
}

export const Wrapper = styled.div<WrapperProps>`
	display: flex;
	align-items: center;
	font-family: 'Arial', sans-serif;
	font-size: 18px;
	color: #000000;

  flex-direction: ${props => props.$direction || 'row'};
  gap: ${props => props.$gap || '0px'};
`;

export const CheckboxInput = styled.input`
	appearance: none;
	-webkit-appearance: none;
	width: 20px;
	height: 20px;
	border: 2px solid ${MAIN_COLOR};
	border-radius: 8px;
	margin-right: 8px;
	outline: none;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: transparent;

	&:checked {
		background-color: ${MAIN_COLOR};
	}

	&:checked::after {
		content: '✔';
		color: white;
		font-size: 16px;
	}
`;
